export default {
    data () {
        return {
            multiple_selected: (this.value || []).slice(0),
        };
    },
    methods: {
        multiple_input (item) {
            if (item.id === null) {
                this.multiple_selected.splice(0, this.multiple_selected.length);
                return;
            }

            const selectAllOption = this.values.find((item) => item.selectAllOption);
            if (item.selectAllOption) {
                if (selectAllOption && selectAllOption.id !== null && this.multiple_selected.includes(selectAllOption.id)) {
                    this.multiple_selected = [];
                    return;
                }
                this.multiple_selected = this.values.map((option) => option.id);
                return;
            }

            let index = this.multiple_selected.indexOf(item.id);
            if (index === -1) {
                if (item.exclusive || this.private_exclusives.indexOf(this.multiple_selected[0]) !== -1) {
                    this.multiple_selected.splice(0, this.multiple_selected.length);
                }

                this.multiple_selected.push(item.id);

                // for case if we check all option (not include selectAll option), the selectAll option will be checked automatically
                if (selectAllOption && selectAllOption.id !== null && !this.multiple_selected.includes(selectAllOption.id) && this.multiple_selected.length === this.values.length - 1) {
                    this.multiple_selected.push(selectAllOption.id);
                }
            } else {
                this.multiple_selected.splice(index, 1);

                // for case if the selectAll option is checked -> we uncheck any other option -> selectAll option will be unchecked automatically
                if (selectAllOption && selectAllOption.id !== null && this.multiple_selected.includes(selectAllOption.id)) {
                    this.multiple_selected.splice(this.multiple_selected.indexOf(selectAllOption.id), 1);
                }
            }
        },
        multiple_get (item) {
            return this.multiple_selected.indexOf(item.id) !== -1 || (item.id === null && this.multiple_selected.length === 0);
        },
    },
    computed: {
        private_exclusives () {
            return this.values.filter(item => item.exclusive).map(item => item.id);
        },
    },
    watch: {
        multiple_selected () {
            if (this.value === null || this.value.join('') !== this.multiple_selected.join('')) {
                this.$emit('input', this.multiple_selected.slice(0));
                this.validation_changed();
            }
        },
        value () {
            if (this.value === null || this.multiple_selected.join('') !== this.value.join('')) {
                this.multiple_selected = (this.value || []).slice(0);
            }
        },
    },
};
